import { Reveal, Eyebrow } from "./Reveal";
import { IMAGES } from "./data";

const STATS = [
  ["3", "Premium Pellet Grades"],
  ["30 kg", "Industrial Packaging"],
  ["100%", "Pure Biomass"],
];

export const About = () => (
  <section id="about" data-testid="about-section" className="py-20 lg:py-32">
    <div className="container mx-auto grid grid-cols-1 items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
      <Reveal>
        <Eyebrow>Who We Are</Eyebrow>
        <h2 className="font-display mt-4 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl" data-testid="about-heading">
          About KARM INDUSTRIES
        </h2>
        <p className="mt-6 text-base leading-relaxed text-slate-300 sm:text-lg">
          KARM INDUSTRIES is a bio pellet manufacturing company based at Plot No. 41,
          Amkuhi Industrial Area, Katni, Madhya Pradesh. We convert natural biomass
          into dense, high-energy pellets — a clean, carbon-natural alternative to
          coal and fossil fuels for industrial heating and power.
        </p>
        <p className="mt-4 text-base leading-relaxed text-slate-400">
          Every batch of KARM 006, KARM 008 and KARM 010 is produced with no adhesive
          and no sulphur, delivering high calorific value with low ash — so your
          boilers burn cleaner, longer and more efficiently.
        </p>
        <div className="mt-10 grid grid-cols-3 gap-4" data-testid="about-stats">
          {STATS.map(([num, label]) => (
            <div key={label} className="rounded-xl border border-emerald-500/15 bg-[#0B150F] p-4 text-center sm:p-5">
              <p className="font-display text-2xl font-extrabold text-emerald-400 sm:text-3xl">{num}</p>
              <p className="mt-1 text-[11px] uppercase tracking-wider text-slate-500">{label}</p>
            </div>
          ))}
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="relative">
          <div className="absolute -inset-3 rounded-3xl border border-emerald-500/20" />
          <div className="relative overflow-hidden rounded-2xl">
            <img
              src={IMAGES.hero}
              alt="Inside the KARM INDUSTRIES bio pellet plant — conveyors, processing machinery and finished pellets"
              className="w-full object-cover transition-transform duration-700 hover:scale-105"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#050B07]/70 via-transparent to-transparent" />
            <p className="absolute bottom-4 left-4 font-mono2 text-xs uppercase tracking-widest text-emerald-300">
              Our Plant · Amkuhi Industrial Area, Katni
            </p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
